import { Drawer } from "@mui/material";
import logo from "assets/images/logo.png";
import { Header } from "components/organisms/Header";
import { Main } from "components/organisms/Main";
import { SideBar, SidebarMenu } from "components/organisms/SideBar";
import { ULink } from "components/utils/Link";
import { SandboxUrl } from "configs";
import { Outlet } from "react-router-dom";
import { ProfileMenu } from "routes/profile";
import { mapModifiers } from "utils";

import { useDashboard } from "./hooks";

export interface Props {
  accountInfo?: {
    name: string;
    role: string;
  };
  sidebarMenu: Array<SidebarMenu>;
}

export const Dashboard: React.FC<Props> = ({ accountInfo, sidebarMenu }) => {
  const {
    isSidebarClosed,
    openDrawer,
    mdMatched,
    handleToggleDrawer,
    handleToggleSidebar,
  } = useDashboard();

  return (
    <div
      className={mapModifiers(
        "T-Dashboard",
        isSidebarClosed && "SidebarClosed",
        mdMatched && "MDMatched"
      )}
    >
      <Header
        accountName={accountInfo?.name || ""}
        accountRole={accountInfo?.role}
        profileMenu={ProfileMenu}
        open={!isSidebarClosed}
        onToggle={handleToggleSidebar}
      />
      {mdMatched ? (
        <Drawer
          className="T-Dashboard_Drawer"
          anchor="left"
          open={openDrawer}
          onClose={handleToggleDrawer}
          transitionDuration={350}
        >
          <ULink
            className="T-Dashboard_Logo"
            to={SandboxUrl as string}
            onClick={handleToggleDrawer}
          >
            <img src={logo} alt="Talentnet Logo" />
          </ULink>
          <SideBar
            menu={sidebarMenu}
            close={false}
            version="v1.0.0"
            onClickMenuCallback={handleToggleDrawer}
          />
        </Drawer>
      ) : (
        <SideBar menu={sidebarMenu} close={isSidebarClosed} version="v1.0.0" />
      )}
      <div className="T-Dashboard_Body">
        <div className="T-Dashboard_Content">
          <Main>
            <Outlet />
          </Main>
        </div>
      </div>
    </div>
  );
};
